import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateFormbuilderFieldState } from "./types";
import { IProfileField } from "@/shared/api/profilebuilder";

const initialState: UpdateFormbuilderFieldState = {
    isDeleteFormbuilderFieldModalOpen: false,
    currentField: {
        id: "",
        title: "",
        place_number: 0,
        type: "",
        editable: false,
        required: false,
        profile_template_id: "",
        validation_rules: undefined
    },
    onDelete: null
}

interface OpenDeleteFormbuilderFieldModal {
    onSuccess?: () => void
    data: IProfileField
}

const updateFormbuilderFieldSlice = createSlice({
    name: 'updateFormbuilderField',
    initialState,
    reducers: {
        openDeleteFormbuilderFieldModal: (state, action: PayloadAction<OpenDeleteFormbuilderFieldModal>) => {
            state.isDeleteFormbuilderFieldModalOpen = true
            state.currentField = action.payload.data
            state.onDelete = action.payload.onSuccess
        },
        closeDeleteFormbuilderFieldModal: (state) => {
            state.isDeleteFormbuilderFieldModalOpen = false
        },
    }
})

export default updateFormbuilderFieldSlice.reducer
export const {
    closeDeleteFormbuilderFieldModal,
    openDeleteFormbuilderFieldModal
} = updateFormbuilderFieldSlice.actions